import { ProveedorIdioma } from '@tallerya/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ProveedorSesion } from './sesion/ProveedorSesion';
// Los tokens primero: estilos.css los usa.
import '@tallerya/ui/tokens.css';
import './estilos.css';

const raiz = document.getElementById('root');
if (!raiz) {
  throw new Error('No encontré el div#root en index.html');
}

// El mismo orden que el admin: el idioma afuera, la sesión envolviendo la
// aplicación entera para canjear el código de Keycloak antes de dibujar nada.
//
// Todavía sin `ProveedorDatos` ni `ProveedorAvisos`: la consola no le pide nada a
// la API ni guarda nada hasta M-9, que es quien los agrega.
createRoot(raiz).render(
  <StrictMode>
    <ProveedorIdioma>
      <ProveedorSesion>
        <App />
      </ProveedorSesion>
    </ProveedorIdioma>
  </StrictMode>,
);
